<div [formGroup]="form" class="form-group">
  <label>{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <app-info-icon [message]="field.infoIconMessage" *ngIf="field.infoIconMessage"></app-info-icon>
  <div class="map-iframe-container">
    <iframe
      #locationFieldIframe
      [id]="'location-field-iframe-' + field.name"
      [src]="mapUrl"
      style="width: 100%"
      frameborder="0"
      scrolling="no"
      (load)="onLocationIframeLoad()"
      [ngStyle]="{
        height: customIframeHeight ? '55px' : iframeHeight,
        borderRadius: customIframeHeight ? '0px' : '20px'
      }"
    ></iframe>
  </div>

  <app-validation-errors [control]="form.get(field.name)" [field]="field"></app-validation-errors>
</div>
